import { biBrow, biClick } from '@tencent/fit-bi-sdk';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { showDialog } from '@tencent/wphk-components-dialog';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import dayjs from 'dayjs';
import { ACT_2608_ADTAG_JUMP, ACT_NOT_START_DIALOG, LOTTERY_START_TIME } from '../config';

/** 2608活动是否尚未开始 */
export const isActNotStart = () => dayjs(getServerTime()).isBefore(LOTTERY_START_TIME);

const showActNotStartDialog = () => {
  showDialog({
    content: ACT_NOT_START_DIALOG.content,
    btns: [{
      text: ACT_NOT_START_DIALOG.btnText,
      click: () => {
        biClick('vitasoy-act-2608.not_start_dialog_btn|活动未开始弹窗按钮点击');
        jumpPage.goDiscountCenter({ adtag: ACT_2608_ADTAG_JUMP });
      },
    }],
  });
  biBrow('vitasoy-act-2608.not_start_dialog_brow|活动未开始弹窗曝光');
};

/**
 * 维他Channel页活动未开始拦截
 * 活动开始前进入的用户不渲染页面内容，只弹拦截弹窗引导其前往优惠专区
 */
export const checkVitasoyActNotStart = async () => {
  if (!isActNotStart()) {
    return { isContinue: true };
  }
  showActNotStartDialog();
  return { isContinue: false };
};
